import { Outlet } from 'react-router-dom';
import { TopNav } from './TopNav';
import { PlayerBar } from '@/components/player/PlayerBar';
import { ConsentGate } from '@/components/player/ConsentGate';
import { SmartTuneToast } from '@/components/smart-tune/SmartTuneToast';
import { SmartTuneController } from '@/components/smart-tune/SmartTuneController';
import { ExpandedPlayer } from '@/components/player/ExpandedPlayer';

export function MapLayout() {
  return (
    <div className="relative h-full w-full overflow-hidden bg-navy-950">
      {/* Main map area fills the screen */}
      <div id="main-content" className="absolute inset-0">
        <Outlet />
      </div>

      {/* Smart Tune logic — invisible, monitors map + player */}
      <SmartTuneController />

      {/* Floating top navigation */}
      <TopNav />

      {/* Player consent modal */}
      <ConsentGate />

      {/* Smart Tune non-blocking toast */}
      <SmartTuneToast />

      {/* Expanded full-screen player (mobile) */}
      <ExpandedPlayer />

      {/* Persistent bottom player */}
      <PlayerBar />
    </div>
  );
}
